<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-05-07 15:33:38
 * @Description: file content
 -->
<template>
  <div class="mymodal" v-show="value">
    <div class="msgbox" :class="{ big: message.prizeInfo && message.prizeInfo.prizeType != 1 && message.prizeInfo.prizeType != 11 && !$mobile || message.team, thanks: !message.prizeId, box: message.isBox,mobile: $mobile, key: message.isKey, couponDetail: message.couponDetail }">
      <div class="title">
        <img
          :src="imgHost + `draw_txt${message.drawTxt || 1}.png?v=${$OSSVersion}`"
        />
      </div>
      <template v-if="message.isGroup">
        <div class="group-box">
          <div>
            <div class="tips" v-if="message.drawTxt === 5">拼团成功还差{{message.groupData.finishCount - message.groupData.joinCount}}人<br />赶快邀请好友拼团吧</div>
            <div class="head-img-box">
              <div class="head-img">
                <img :src="message.groupData.users[0].headImg" alt="">
              </div>
              <div class="head-img" v-if="message.groupData.users[1]">
                <img :src="message.groupData.users[1].headImg" alt="">
              </div>
              <div class="head-img" v-else @click="goShare"></div>
              <div class="head-img" v-if="message.groupData.users[2]">
                <img :src="message.groupData.users[2].headImg" alt="">
              </div>
              <div class="head-img" v-else @click="goShare"></div>
            </div>
            <div class="tips" v-if="message.drawTxt === 1">你已经与好友{{message.groupData.users[0].nickName}}拼团成功</div>
          </div>
        </div>
        <div class="btns">
          <div class="my_btn" @click="clickBtn">{{message.btnTxt}}</div>
        </div>
      </template>
      <template v-else-if="message.isBox">
        <div class="box-img" @click="clickBtn">
          <img
            :src="imgHost + 'box'+ message.boxNum + '.png?v=' + $OSSVersion"
          />
        </div>
        <div class="box-txt" :class="'box' + message.boxNum">
          <!-- 恭喜您抽中<span>『{{message.boxName}}盲盒』</span><br />点击盲盒即可获得精美礼品一份！ -->
          恭喜您抽中<span>『{{message.prizeInfo && message.prizeInfo.prizeName}}』</span>
          <br />点击盲盒即可领取奖品！
          <br />继续参与游戏还可获得更多惊喜大礼！
        </div>
      </template>
      <template v-else-if="message.isKey">
        <div class="content">
          <div class="input-box">
            <div class="input_txt">
              <input @blur="blurInput" v-model="key" type="text" placeholder="请输入密钥:" />
            </div>
          </div>
        </div> 
        <div class="btns">
          <!-- <div :class="'my_btn' + message.btnStatus" @click="clickBtn"></div> -->
          <div class="my_btn" @click="submitKey">{{message.btnTxt}}</div>
        </div>
      </template>
      <template v-else-if="!message.prizeId">
        <div class="content">
          <div class="tip3" v-html="message.thanksTxt"></div>
        </div> 
        <div class="btns">
          <!-- <div :class="'my_btn' + message.btnStatus" @click="clickBtn"></div> -->
          <div class="my_btn" @click="clickBtn">{{message.btnTxt}}</div>
        </div>
      </template>
      <template v-else-if="message.prizeInfo">
        <div class="content">
          <div class="tip2" v-if="(message.prizeInfo.prizeType === 1 || message.prizeInfo.prizeType === 11) && !message.user">获得{{ message.prizeInfo.prizeName}}，<br />请正确填写以下信息进行发放！<br />传播活动还有更多额外「金」喜哦！</div>
          <div class="tip2" v-else-if="message.prizeInfo.prizeType === 1 && message.user">恭喜您成功帮助好友获得一个人气值！<br/>{{message.user.fromOpenName}}托我们为您送上<br/>一份「金」喜，至多200元！<br/>请正确填写领奖信息进行发放。</div>
          <div class="tip2" v-else-if="message.prizeInfo.workScene === 8">请正确填写信息<br />加入拼团<br />提交后完成支付<br />即可成功加入拼团。</div>
          <!-- <div class="tip2" v-else-if="message.prizeInfo.prizeType === 3"><br />恭喜您获得{{message.prizeInfo.prizeName}}<br />稍后将兑换码发送到您的手机上，<br />请根据活动规则领取奖品。</div> -->
          <div class="tip2" v-else>恭喜您获得{{message.prizeInfo.prizeName}}，<br />请正确填写信息、选择意向领奖城市<br />稍后将兑换码发送到您的手机上，<br />请根据活动规则领取奖品。</div>
          <div class="input-box">
            <div class="input_txt" v-if="message.prizeInfo.prizeType != 1 && message.prizeInfo.prizeType != 11 && message.prizeInfo.prizeType != 3">
              <input @blur="blurInput" v-model="name" type="text" placeholder="姓名：" />
            </div>
            <div class="input_txt" v-if="!$mobile || message.prizeInfo.prizeType === 1 || message.prizeInfo.prizeType === 11 || message.team">
              <input @blur="blurInput" v-model="mobile" type="tel" placeholder="联系方式：" />
            </div>
            <div class="input_txt" v-if="!$mobile || message.prizeInfo.prizeType === 1 || message.prizeInfo.prizeType === 11 || message.team">
              <div class="left">
                <input @blur="blurInput" v-model="vcode" type="number" placeholder="验证码：" oninput="if(value.length>6)value=value.slice(0,6)" />
              </div>
              <div class="right">
                <div @click="getVcode" v-if="!showVcode">{{getVcodes}}</div>
                <div v-else>{{counts}}s</div>
              </div>
            </div>
            <div class="input_txt" v-if="message.prizeInfo.prizeType != 1 && message.prizeInfo.prizeType != 11 && message.prizeInfo.prizeType != 3">
              <Multiselect
                v-model="userAdress"
                :options="addrList"
                placeholder="请选择意向领奖地址"
                :searchable="false"
                @input="selectAddr"
                :allow-empty="false"
                :show-labels="false"
                track-by="name"
                label="name"
              >
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
              </Multiselect>
            </div>
          </div>
        </div>
        <div class="btns" :class="{discard: message.prizeInfo.prizeType != 1 }">
          <div class="my_btn" @click="submit">{{message.prizeInfo.workScene == 8 ? '去支付' : '提交'}}</div>
          <!-- <div class="my_btn" @click="discard" v-if="message.prizeInfo.prizeType != 1 && !message.isCoupon">放弃重抽</div> -->
        </div>
      </template>
      <img
        class="close"
        @click="clickClose"
        :src="'https://assets.rurushishi.com/activies/common/close.png?v=' + $config.OSSVersion"
        alt
      />
    </div>
  </div>
</template>

<script>
import httphdk from "@/http/henduoke-platform";
import apihdk from "@/api/henduoke-platform";
import md5 from "js-md5";
import { MessageBox, Toast, Indicator } from "mint-ui";
import Multiselect from "vue-multiselect";
import Vue from "vue/dist/vue.js";
export default {
  components: { Multiselect },
  props: {},
  data() {
    return {
      value: false,
      title: "",
      message: "",
      callback: null,
      userInfo: this.$userInfo,
      vcode: "",
      name: "",
      mobile: "",
      key: '',
       //选则领奖地址
      userAdress: [],
      addressId: "",
      addressName: '',
      addrList: [],
      counts: "",
      timers: null,
      getVcodes: "获取验证码",
      showVcode: false,
      prizeId: 0,
    };
  },
  watch: {
    value: function(newVal) {
      if (newVal) {
        this.message.prizeId && this.getPrizeById(this.message.prizeId)
        this.showVcode = false;
        clearInterval(this.timers);
        this.timers = null;
        this.vcode = "";
        this.userAdress = []
        this.addressId = ""
        this.addressName = ''
        this.key = ''
      }
    }
  },
  computed: {
    payUrl() {
      return `${this.$config.env.prod.apiActLogicDengfan.protocol}//${this.$config.env.prod.apiActLogicDengfan.domain}/${this.$config.apiName}/`
    }
  },
  methods: {
    async clickBtn() {
      if (this.message.isBox) {
        this.value = false;
        this.callback("box")
      } else if (this.message.isKey) {
        this.value = false;
        this.callback("key")
      } else if (this.message.btnStatus == 1 || this.message.btnTxt === '呼朋唤友' || this.message.btnTxt === '去分享') {
        this.goShare()
      } else if(this.message.btnStatus == 2 || this.message.btnTxt === '去抽奖') {
        this.value = false;
        this.callback("draw")
      } else if(this.message.btnTxt === '马上领取') {
        this.value = false;
        this.callback("redPac")
      } else if(this.message.btnTxt === '我知道了') {
        this.value = false;
        this.callback("cancel")
      } else if(this.message.isGroup) {
        this.value = false;
        this.callback("myprize")
      }
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      this.temporaryRepair();
    },
    // 获取对应奖品的地址
    async getPrizeById(prizeId) {
      let data
      if(this.message.isSecretDraw) {
       data = await this.$httpdf.get(this.apiHost + 'secret/getPrizeById', { prizeId: prizeId }) 
      } else {
        data = await this.$httpdf.get(this.apiHost + 'lucky/prize/getPrizeById', { prizeId: prizeId })
      }
      if (data.code == 0) {
        this.prizeId = prizeId
        this.$set(this.message, 'prizeInfo', data.data.prize)
        if (data.data.address) {
          this.addrList = [];
          // debugger
          data.data.address.forEach((v, i) => {
            this.addrList.push({
              addressId: v.addressId,
              addressName: v.addressName,
              name: v.addressName,
              id: i
            })
          })
          this.addrList.length === 1 && this.selectAddr(this.addrList[0])
        }
      } else {
        MessageBox.alert(data.msg);
      }
    },
    selectAddr: function (data) {
      this.userAdress = data;
      this.addressName = data.addressName;
      this.addressId = data.addressId;
    },
    //获取验证码
    async getVcode() {
      const TIME_COUNT = 60;
      if (!this.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        //获取验证码
        let parm = new FormData();
        parm.append("mobile", this.mobile);
        const data = await this.$httpdf.post(this.apiHost + `common/smsCode`, parm)
        if (data.code == 0) {
          Toast({
            message: "验证码已发送至您的手机",
            duration: 2000,
          });
          if (!this.timers && this.mobile) {
            this.counts = TIME_COUNT;
            this.showVcode = true;
            this.timers = setInterval(() => {
              if (this.counts > 0 && this.counts <= TIME_COUNT) {
                this.counts--;
              } else {
                this.showVcode = false;
                clearInterval(this.timers);
                this.timers = null;
              }
            }, 1000);
          }
        } else {
          MessageBox.alert(data.msg);
        }
      }
    },
    //提交手机号
    async submit() {
      if (!this.name) {
        return MessageBox.alert("请输入姓名", "提示");
      } else if (!this.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        if (!this.$util.isMobile(this.mobile) && !this.$mobile) {
          return MessageBox.alert("请填写正确的手机号", "提示");
        }
      }
      if (!this.vcode && !this.$mobile) {
        return MessageBox.alert("请输入验证码", "提示");
      }
      if (this.message.prizeInfo.prizeType !== 1 && this.message.prizeInfo.prizeType != 11 && this.message.prizeInfo.prizeType !== 3) {
        if (!this.addressId) {
          return MessageBox.alert("请选择兑奖地址", "提示");
        }
      }
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle",
      });
      if (this.message.prizeInfo.prizeType !== 1 && this.message.prizeInfo.prizeType != 11) {
        let parm = {}
        if (!this.addressId) {
          this.selectAddr(this.addrList[0])
        }
        if (this.$mobile) {
          parm = {
            addressId: this.addressId,
            addressName: this.addressName,
            name: this.name,
            prizeId: this.message.prizeId
          }
        } else {
          parm = {
           addressId: this.addressId,
           addressName: this.addressName,
           code: this.vcode,
           mobile: this.mobile,
           name: this.name,
           prizeId: this.message.prizeId
         }
        }
        let data
        if(this.message.isSecretDraw) {
          data = await this.$httpdf.get(this.apiHost + 'secret/receive', parm)
        } else if (this.message.team) {
          // 拼团
          data = await this.$httpdf.get(this.apiHost + 'prize/checkProjectAndMobile', {
            mobile: this.mobile,
            prizeId: this.prizeId,
            projectId: this.addressId,
            verCode: this.vcode
          })
        } else {
          data = await this.$httpdf.get(this.apiHost + 'lucky/prize/receive', parm)
        }
        if (data.code == 0) {
          this.handlerSuccess()
        } else {
          Indicator.close();
          MessageBox.alert(data.msg);
        }
      } else {
        let url
        let data
        if(this.$mobile) {
          if(this.message.user || this.message.freeRedPac) {
            url = `${this.apiHost}lucky/prize/receiveFreeRedPac?prizeId=${this.message.prizeId}&name=${this.name}`;
          } else if(this.message.isSecretDraw) {
            url = `${this.apiHost}secret/receiveRedPac?prizeId=${this.message.prizeId}&name=${this.name}`;
          } else {
            url = `${this.apiHost}lucky/prize/receiveRedPac?prizeId=${this.message.prizeId}&name=${this.name}`;
          }
        } else {
          if(this.message.user || this.message.freeRedPac) {
            url = this.apiHost + `lucky/prize/receiveFreeRedPac?mobile=${this.mobile}&code=${this.vcode}&prizeId=${this.message.prizeId}&name=${this.name}`;
          } else if(this.message.isSecretDraw) {
            url = `${this.apiHost}secret/receiveRedPac?mobile=${this.mobile}&code=${this.vcode}&prizeId=${this.message.prizeId}&name=${this.name}`;
          } else {
            url = this.apiHost + `lucky/prize/receiveRedPac?mobile=${this.mobile}&code=${this.vcode}&prizeId=${this.message.prizeId}&name=${this.name}`;
          }
        }
        data = await this.$httpdf.get(url)
        if (data.code == 0) {
          this.handlerSuccess()
        } else {
          Indicator.close();
          MessageBox.alert(data.msg);
          if (data.msg === '手慢了~奖品已被抢完') {
            if (this.message.isLight) {
              this.value = false;
              this.callback("draw")
            } else {
              this.value = false;
              this.callback("cancel")
            }
          }
        }
      }
    },
    async submitKey() {
      if (!this.key) {
        return MessageBox.alert("请输入秘钥", "提示");
      }
      // 验证秘钥是否正确
      const data = await this.$httpdf.post(this.apiHost + 'secret/checkSecretKey', { secret: this.key })
      if (data.data === true) {
        this.value = false;
        this.callback({ secret: this.key })
      } else { 
        return MessageBox.alert(data.msg, "提示");
      }
    },
    handlerSuccess() {
      Indicator.close();
      if (!this.message.team) { 
         Toast({
          message: "领取成功",
          duration: 2000,
        });
      }
      this.$config.openYqAnalytics && this.$biz.handlerYqAnalyticsEvent('entryPhoneNumber', {
        phoneNumber: this.mobile,
        type: 14,
        bizSource: 8
      })
      Vue.prototype.$mobile = this.mobile
      this.$util.cookie.set("mobile", this.$mobile, {
        expires: 60,
      });
      this.$config.openYqAnalytics && this.$biz.handlerYqAnalyticsSetUserInfo()
      if (this.$config.openSalesLeads) {
        this.$rsh5.actEntry(this.mobile)
        this.$rsh5.actUserEvent({
          phone: this.mobile,
          userevent: "wheel_draw",
          usereventValue: this.mobile,
          usereventDesc:`${this.name}参与了${this.$config.pageTitle}的助力活动，并获得了${this.message.prizeInfo.prizeName}`,
        })
      }
      if (this.message.isLight) {
        this.value = false;
        this.callback("draw")
      } else if (this.message.team) {
        let _self = this;
        let times = Math.round(new Date().getTime() / 1000);
        let signs = `forceWjj=1&orderType=3&mobile=${_self.mobile}&time=${times}&verCode=${_self.vcode}&key=${_self.$key}`;
        let obj = {
          expandParams: JSON.stringify({
            addressId: _self.addressId,
            addressName: _self.addressName
          }),
          forceWjj: 1,
          name: _self.name,
          mobile: _self.mobile,
          verCode: _self.vcode,
          orderType: 3,
          groupId: _self.message.groupId,
          time: times,
          prizeId: _self.prizeId,
          sign: md5(signs),
        };
        let query = JSON.stringify(obj);
        let okUrl = `${this.$site}#/team?prizeId=${this.prizeId}&channel=${this.$channel}&fopenid=${this.$openid}`;
        let dm = `query=${query}&rurl=${encodeURIComponent(okUrl)}&appId=${
          this.$appid
        }&openId=${this.$openid}&infoId=${this.$infoId}&channel=${
          this.$channel
        }&reQuest=${encodeURIComponent(this.payUrl)}&fromOpenId=${
          this.$fopenid || ''
        }`;
        httphdk
          .get("", {
            action: apihdk.action.paymentUrl,
            requestParam: {
              folder: "commonActPay",
              params: dm,
            },
          })
          .then((data) => {
            if (data.data.code == 0) {
              window.location.href = data.data.obj;
            }
          });
      } else {
        this.value = false;
        this.callback("cancel")
      }
    },
    clickClose() {
      if (!this.message.isMyprize && this.message.prizeId && !this.message.lightId && !this.message.user &&!this.message.team) {
        MessageBox({
          title: '提示',
          // message: '现在退出弹窗，该奖品将在首页【我的礼品】中保留2分钟领取时间，超时不领取奖品将会释放给其他用户哦～请您慎重考虑！',
          message: '现在退出弹窗，视为放弃奖品，奖品将会释放给其他用户哦～请您慎重考虑！',
          showCancelButton: true
        }).then(async (action) => {
          if (action === 'confirm') {
            this.discard()
            // this.value = false;
            // this.callback("cancel")
          }
        })
      } else {
        this.value = false;
        this.callback("cancel")
      }
    },
    async discard() {
      await this.$httpdf.get(this.apiHost + 'lucky/prize/discard', { prizeId: this.message.prizeInfo.id })
      this.value = false;
      this.callback("cancel")
    }
  },
  created() {
  },
  mounted() {
    if (this.$userInfo) {
      this.name = this.$userInfo.nickName;
    }
    if (this.$mobile) {
      this.mobile = this.$mobile
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.msgbox {
  position: relative;
  width: 324px;
  height: 387px;
  background: url( $imgHost + 'draw_form1.png?v=' + $OSSVersion) center 0 / 100% no-repeat;
  box-sizing: border-box;
  padding: 97px 47px 0;
  &.big {
    height: 477px;
    background: url( $imgHost + 'draw_form2.png?v=' + $OSSVersion) center 0 / 100% no-repeat;
    .content {
      .input-box {
        margin-top: 10px;
      }
      .tip2 {
        line-height: 18px;
      }
    }
  }
  &.thanks {
    height: 357px;
    background: url( $imgHost + 'draw_form3.png?v=' + $OSSVersion) center 0 / 100% no-repeat;
    padding: 97px 57px 0;
    .content {
      padding-top: unset;
      min-height: unset;
    }
  }
  &.mobile {
    .content {
      .tip2 {
        line-height: 19px;
      }
      .input-box {
        margin-top: 8px;
      }
    }
  }
  &.box {
    width: 375px;
    height: 346px;
    background: url( $imgHost + 'light.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    padding-top: 107px;
    margin-top: 50px;
    text-align: center;
    align-self: flex-start;
    .box-img {
      position: relative;
      animation: scaleAni 1s;
      img {
        width: 231px;
      }
      &::after {
        display: block;
        content: '';
        width: 84px;
        height: 58px;
        background: url('https://assets.rurushishi.com/activies/common/icon_head_big.png?v=' + $OSSVersion) center / 100% no-repeat;
        position: absolute;
        bottom: -10px;
        right: 10px;
        animation: twinkle 1s infinite linear;
      }
    }
    .box-txt {
      margin-top: 46px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 36px;
      white-space: nowrap;
      span {
        font-size: 20px;
        color: #EB7B37;
      }
    }
    .close {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 31px;
      height: 31px;
      z-index: 2000;
    }
  }
  &.key {
    height: 357px;
    background: url( $imgHost + 'draw_form3.png?v=' + $OSSVersion) center 0 / 100% no-repeat;
    .content {
      width: 100%;
      height: 150px;
      padding-bottom: 30px;
      @extend .flex-center-center;
    }
  }
  &.couponDetail {
    height: 414px;
    background: url( $imgHost + 'draw_form4.png?v=' + $OSSVersion) center 0 / 100% no-repeat;
    padding: 97px 57px 0;
    .content {
      .tip3 {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #D04B0A;
        line-height: 20px;
        height: 205px;
        text-align: justify;
        text-justify: inter-ideograph;
      }
    }
  }
  .title {
    margin: 0 auto 10px;
    text-align: center;
    img {
      width: auto;
      height: 24px;
    }
  }
  .group-box {
    height: 150px;
    @extend .flex-center-center;
    >div {
      width: 100%;
    }
    .tips {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FEFEFE;
      line-height: 180%;
      text-align: center;
    }
    .head-img-box {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 15px 30px;
      .head-img {
        width: 38px;
        height: 38px;
        background: url( $imgHost + 'icon3.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
        &:nth-child(1) {
          position: relative;
          &::after {
            content: '拼主';
            display: block;
            position: absolute;
            top: -7px;
            left: -5px;
            width: 28px;
            height: 15px;
            line-height: 15px;
            border: 1px solid #FFFFFF;
            background: linear-gradient(90deg, #EE9038 0%, #EA5E2B 100%);
            font-size: 9px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #FFFFFF;
            border-radius: 25px;
            text-align: center;
          }
        }
        img {
          border-radius: 50%;
          border: 1px solid #ED7750;
        }
      }
    }
  }
  .content {
    min-height: 182px;
    padding-top: 5px;
    text-align: center;
    .tip2 {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FEFEFE;
      line-height: 20px;
      text-align: center;
    }
    .tip3 {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 24px;
      height: 150px;
      @extend .flex-center-center;
    }
    .input-box {
      width: 100%;
      margin-top: 15px;
    }
    .input_txt {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &+.input_txt {
        margin-top: 12px;
      }
      .left {
        flex: 1;
        input {
          width : 100%;
        }
      }
      .right {
        width: 75px;
        height: 36px;
        background: #FA792C;
        border-radius: 5px;
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #fff;
        margin-left: 11px;
        @extend .flex-center-center;
      }
      input {
        box-sizing: border-box;
        background: #fff;
        border-radius: 5px;
        width: 100%;
        height: 36px;
        line-height: 36px;
        text-indent: 10px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #F24617;
        &::-webkit-input-placeholder{
          color: #999;
        }
      }
      .multiselect {
        min-height: auto;
      }
      ::v-deep .multiselect__tags {
        height: 36px !important;
        line-height: 36px !important;
        min-height: 36px !important;
        border: 0;
        padding-top: 0;
        padding-left: 10px;
        box-sizing: border-box;
        background: #fff;
        border-radius: 5px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #F24617;
        .multiselect__input, .multiselect__single{
          background-color: transparent;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0;
          margin: 0;
          line-height: 36px !important;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #F24617;
        }
        .multiselect__placeholder {
          line-height: 36px !important;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          padding: 0;
          color: #999;
        }
      }
      ::v-deep .multiselect__select {
        height: 36px;
        &::before {
          color: #F24617;
          border-color: #F24617 transparent transparent;
        }
      }
      ::v-deep .multiselect__option {
        white-space: normal;
      }
    }
    
  }
  .btns {
    // z-index: 9;
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 25px;
    .my_btn {
      width: 170px;
      height: 39px;
      background: linear-gradient(180deg, #FCCD94 0%, #F88C41 100%);
      box-shadow: 0px 3px 6px 0px rgba(192, 81, 39, 0.8);
      border-radius: 20px;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      @extend .flex-center-center;
      &+.my_btn {
        margin-left: 10px;
      }
    }
    // &.discard {
    //   .my_btn {
    //     font-size: 16px;
    //     letter-spacing: 0;
    //   }
    // }
    &.group {
      margin-top: 45px;
    }
  }
  .close {
    position: absolute;
    top: 110%;
    left: 50%;
    transform: translateX(-50%);
    width: 31px;
    height: 31px;
    z-index: 2000;
  }
}
</style>